import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'
import variationState from './variations/state'
import variationActions from './variations/actions'
import variationGetters from './variations/getters'
import variationMutations from './variations/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { ...state, ...variationState },
  getters: { ...getters, ...variationGetters },
  actions: { ...actions, ...variationActions },
  mutations: { ...mutations, ...variationMutations }
})
